//import moment from 'moment';
//import router from '../router';

export { initSession };

function initSession() {
    /*
    return new Promise((resolve) => {
        let tokenExpiryDate = window.localStorage.getItem('tokenExpiration');
        if (!tokenExpiryDate) {
            console.log("Não existe data de expiração do token. Usuário provavelmente não autenticado.")
            router.push({ name: 'login' });
        }
        let tenMinutesBeforeExpiry = moment(tokenExpiryDate).substract(10, 'minutes');
        const now = new moment().local();

        if (isAfter(now, tenMinutesBeforeExpiry)) {
            alert("Sua sessão irá expirar em 10 minutos. Refaça o login assim que puder.");
            console.log("Token expirado/vai expirar nos próximos 10 minutos");
        }

        console.log("Token OK. Irá expirar em: " + tokenExpiryDate);

    });
    */
}

/*
function isAfter(dateIni, dateEnd) {
    return dateIni.isAfter(dateEnd);
}
*/